/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Color_Role_PrimaryInputs */

const en_enum_color_role_primary = /** @type {(inputs: Enum_Color_Role_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Primary`)
};

const de_enum_color_role_primary = /** @type {(inputs: Enum_Color_Role_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Primary`)
};

/**
* | output |
* | --- |
* | "Role Primary" |
*
* @param {Enum_Color_Role_PrimaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_color_role_primary = /** @type {((inputs?: Enum_Color_Role_PrimaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Color_Role_PrimaryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_color_role_primary(inputs)
	return de_enum_color_role_primary(inputs)
});